/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAttributeValuesPathParams = NonNullable<operations['getAttributeValues']['parameters']['path']>;

export type GetAttributeValuesQueryParams = NonNullable<operations['getAttributeValues']['parameters']['query']>;

export interface Input extends GetAttributeValuesPathParams {
  apiVersion?: string;
  query?: GetAttributeValuesQueryParams;
}

export async function getAttributeValues(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/api/v2/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/iterations/{iterationId}/attributes/{attribute}',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
